import { Achievement } from "../models/achievement.model";

export const ACHIEVEMENTS: Achievement[] = [
  {
    'fileName': 'achievement-01.png',
    'num': '350+',
    'desc': '我们的导师'
  },
  {
    'fileName': 'achievement-02.png',
    'num': '98%',
    'desc': '我们的推荐信'
  },
  {
    'fileName': 'achievement-03.png',
    'num': '85%',
    'desc': '我们的offer'
  },
  {
    'fileName': 'achievement-04.png',
    'num': '99.9%',
    'desc': '满意度'
  },
  {
    'fileName': 'achievement-05.png',
    'num': '遍布全球',
    'desc': '我们的学生'
  }
];



// WEBPACK FOOTER //
// C:/Users/anach/Desktop/tengtu-website/src/app/data/achievements.ts